<template>
    <label class="def-input-component">
        <span class="def-input-component__label">
            {{ label }}
        </span>
        <input
            :type="type"
            :name="name"
            :required="required"
            :value="saveValue"
            :autocomplete="autocomplete"
            :id="id"
            :form="form"
            :readonly="readonly"
            :pattern="pattern"
            :placeholder="placeholder"
            :class="{
                'def-input-component__invalid': !isValid
            }"
            @input="handlerInput"
            @change="$emit('change', $event)"
            @click="$emit('click', $event)"
            @keypress="$emit('keypress', $event)"
            @keydown="$emit('keydown', $event)"
            @keyup="$emit('keyup', $event)"
            @invalid.prevent="handlerInvalid"
            @blur="handlerBlur"
            class="def-input-component__input"
        >
    </label>
</template>

<script>
export default {
    name: 'DefInput',
    props: {
        name: String,
        placeholder: String,
        required: Boolean,
        autocomplete: Boolean,
        value: {
            type: String,
            default: '',
        },
        modelValue: {
            type: String,
            default: '',
        },
        id: String,
        form: String,
        type: {
            type: String,
            default: 'text',
        },
        readonly: {
            type: Boolean,
            default: false
        },
        pattern: {
            type: [String, null],
            default: null,
        },
        label: {
            type: String,
        }
    },
    data() {
        return {
            isValid: true,
            isFocus: false,
            saveValue: this.value,
        }
    },
    methods: {
        handlerInput(e) {
            this.saveValue = e.target.value;
            this.$emit('input', e);
            this.$emit('update:modelValue', this.saveValue);
        },
        handlerInvalid(e) {
            if (this.required) {
                this.isValid = false;
            }

            this.$emit('invalid', e);
        },
        handlerBlur(e) {
            const target = e.target;
            if (target.checkValidity() && this.required) {
                this.isValid = true;
            }
            this.$emit('blur', e);
        },
    },
    watch: {
        value(newValue) {
            this.saveValue = newValue;
        },
        modelValue(newValue) {
            this.saveValue = newValue;
        },
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.def-input-component {
    display: inline-block;

    &__label {
        display: block;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        @include point-lg{
            font-size: 18px;
            line-height: 28px;
        }
    }

    &__input {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        border: 1px solid #D9D9D9;
        border-radius: 4px;
        height: 50px;
        transition: .2s linear border-bottom-color;
        padding: 0 22px;
        width: 100%;

        &::placeholder {
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px;
        }
    }

    &__invalid {
        border-color: var(--danger);
    }
}
</style>